import axios from 'axios';
import {EnvironmentConfig} from "@me8eon/config";

interface PollResponse {
  body?: any;
  options?: any[];
  outputText?: boolean;
  updatedAt: string;
}

export const callServiceNowAPI = async (
  payload: any,
  headers: any,
  maxAttempts = 3,
  interval = 1000
) => {
    for (let attempt = 1; attempt <= maxAttempts; attempt++) {
      try {
        const response = await axios.post(`${EnvironmentConfig.gatewayURL}/proxy/sn_va_as_service/bot/integration`, payload, { headers });
        if (response.data.status === 'success') {
          return true;
        }
      } catch (error) {
        console.warn(`Attempt ${attempt} failed:`, error);
      } finally {
        await delay(interval);
      }
    }
    throw new Error('SNOW API Failed');
}

export const pollBackendAPI = async (
  payload: { sessionId: string; timestamp: string },
  headers: Record<string, string>,
  condition: (context: Record<string, any>) => boolean,
  extractResult: (matched: any) => any,
  maxAttempts = 10,
  interval = 1000
): Promise<PollResponse> => {
  const url = `${EnvironmentConfig.gatewayURL}/proxy/virtual-agent/messages`;
  let latestUpdatedAt = payload.timestamp;
  for (let attempt = 1; attempt <= maxAttempts; attempt++) {
    try {
      const response = await axios.get(`${url}?clientSessionID=${payload.sessionId}&updatedAt=${latestUpdatedAt}`, { headers });
      const { status, data = [] } = response.data || {};
      if (status !== 'success' || !Array.isArray(data) || data.length === 0) {
        await delay(interval);
        continue;
      }

      const matched = data.find((msg: any) => condition(msg));
      if (matched) {
        latestUpdatedAt = matched?.updatedAt || latestUpdatedAt;
        const result = extractResult(matched);
        if (result) {
          return { ...result, updatedAt: latestUpdatedAt };
        }
      }

      await delay(interval);
    } catch (error) {
      console.warn(`Attempt ${attempt} failed:`, error);
      await delay(interval);
    }
  }
  throw new Error('Backend API failed');
};

export const delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));